import type { ReactNode } from 'react';
import { PaginaAyuda, Captura, Pasos } from '../shared/Ayuda.tsx';

export function AyudaClientePage(): ReactNode {
  return (
    <PaginaAyuda
      titulo="Manual del Portal"
      intro="Todo lo que podés hacer desde acá, explicado en simple."
      accent="verde"
      secciones={[
        {
          id: 'solicitudes',
          titulo: 'Mis solicitudes: cómo viene cada pedido',
          contenido: (
            <>
              <p>Cada tarjeta es un evento tuyo. El estado te dice todo:</p>
              <Pasos
                items={[
                  <><strong>Confirmada 4/4</strong>: toda la gente aceptó. No tenés que hacer nada.</>,
                  <><strong>Pendiente 2/4</strong>: ya aceptaron 2, faltan 2 (las convocatorias siguen dando vueltas solas).</>,
                  <>Desplegá la tarjeta para ver quién viene y a qué hora entra cada uno.</>,
                  <>Con los filtros <strong>Hoy / Esta semana / Semana que viene</strong> mirás justo lo que se viene.</>,
                ]}
              />
              <Captura src="cliente-solicitudes.png" alt="Mis solicitudes" pie="Tus pedidos con las confirmaciones al día." />
            </>
          ),
        },
        {
          id: 'nueva',
          titulo: 'Nueva solicitud: pedir personal',
          contenido: (
            <>
              <Pasos
                items={[
                  <>Elegí salón, fecha y horario. Con los botones <strong>6 h / 8 h / 9 h</strong> la hora de fin se calcula sola (los eventos que terminan de madrugada están contemplados).</>,
                  <>Marcá cuántas personas necesitás de cada categoría con el <strong>+</strong>.</>,
                  <>¿Entran en tandas? Una categoría puede tener <strong>varios turnos con distinto horario</strong>: tocá "＋ Agregar otro turno con distinto horario" (ej.: 4 mozos a las 20:00 y otros 4 a las 02:00).</>,
                  <>Si querés gente puntual, buscala por <strong>nombre o cédula</strong> y marcala. Lo que no elijas, se asigna solo.</>,
                  <>Revisá el <strong>Resumen del pedido</strong> al final: quién va con ✓ y cuántos salen por asignación automática ⚡, turno por turno. Recién ahí tocá "Crear solicitud".</>,
                ]}
              />
              <Captura src="cliente-nueva.png" alt="Nueva solicitud con turnos" pie="Dos turnos de mozo con horarios distintos y el resumen." />
            </>
          ),
        },
        {
          id: 'historial',
          titulo: 'Historial y servicios realizados',
          contenido: (
            <>
              <p>
                En <strong>Historial</strong> están todas tus solicitudes pasadas, agrupadas por semana y con filtros
                por salón y estado.
              </p>
              <p>
                En <strong>Servicios realizados</strong> ves lo que efectivamente pasó: por mes y por salón, cada
                persona con su hora de entrada y salida reales, las horas trabajadas y el <strong>costo</strong> que te
                factura la empresa. Es tu control contra el recibo semanal.
              </p>
              <Captura src="cliente-servicios.png" alt="Servicios realizados" pie="Lo trabajado con horas reales y costo." />
            </>
          ),
        },
        {
          id: 'qr',
          titulo: 'Código QR: el fichaje en tu salón',
          contenido: (
            <p>
              En <strong>Código QR</strong> está el código de tu club (se renueva solo cada 30 segundos). Dejalo visible
              en una pantalla con el modo <strong>kiosk</strong> (pide tu PIN) y el personal marca llegada y salida
              escaneándolo. La app detecta sola en qué salón están.
            </p>
          ),
        },
      ]}
    />
  );
}
